import { WARRCHIRP_EXPERIENCE_API_URL } from 'config';
import type { GetAgentByRooftopResponseDTO } from 'declarations/dto/agents';

import { get } from './api';

export const getAgentsByRooftop = async (
  rooftopIds: string[] | undefined
): Promise<GetAgentByRooftopResponseDTO[]> => {
  const rooftopParams = rooftopIds
    ?.map(rooftop => rooftop)
    .toString()
    .replaceAll(',', '&roofTopIds=');
  const response = await get<GetAgentByRooftopResponseDTO[]>(
    `/users/by-rooftops?roofTopIds=${rooftopParams}`,
    {},
    {
      baseURL: `${WARRCHIRP_EXPERIENCE_API_URL}`,
    }
  );

  return response.data;
};
